<template>
  <figure
    :class="{ 'has-caption': data.caption, 'background-image': background }"
    class="image-hold"
  >
    <div
      :class="[
        { useholder: placeholder, 'hero-thumb': hero, lazyloading: lazy },
        insideclass
      ]"
      class="wp-image"
    >
      <img
        v-if="!background"
        :src="lazy ? imagePlaceholder : imageUrl"
        :srcset="lazy ? srcSet : ''"
        :data-src="imageUrl"
        :data-srcset="srcSet"
        :data-alt="data.alt"
        :class="{ lazyload: lazy }"
      />
      <div
        v-else
        class="bg-image"
        :class="{ lazyload: lazy, 'not-lazyload': !lazy }"
        :data-bg="imageUrl"
        :style="!lazy ? 'background-image: url(' + imageUrl + ')' : ''"
      ></div>
      <div
        class="lazy-placeholder"
        :style="'background-image: url(' + imagePlaceholder + ')'"
        v-if="placeholder"
      ></div>
      <slot class="slot-in" name="in"></slot>
    </div>
    <figcaption
      v-if="(data.description && caption) || (data.title && title)"
      role="description"
    >
      <span v-if="title" class="title">{{ data.title }}</span>
      <span v-if="caption" class="caption">{{ data.description }}</span>
    </figcaption>
    <slot class="slot-out" name="out"></slot>
  </figure>
</template>

<script>
export default {
  name: "wp-image",
  props: {
    data: Object,
    size: { type: String, default: "medium" },
    caption: { type: Boolean, default: false },
    title: { type: Boolean, default: false },
    lazy: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: false
    },
    hero: {
      type: Boolean,
      default: false
    },
    insideclass: String
  },
  mounted: function() {
    const VM = this;
    VM.imageUrl = VM.data.url;
    if (VM.size && VM.size != "") {
      if (
        typeof VM.data.sizes[VM.size] !== "undefined" &&
        VM.data.sizes[VM.size]
      ) {
        VM.imageUrl = VM.data.sizes[VM.size]["url"];
      } else if (VM.size === "full") {
        VM.imageUrl = VM.data.sizes.full["url"];
      }
    }
  },
  data() {
    return {
      imageUrl: ""
    };
  },
  computed: {
    imagePlaceholder() {
      if (this.data.sizes.min) {
        return this.data.sizes.min["url"];
      } else {
        if (this.data.sizes.thumbnail) {
          return this.data.sizes.thumbnail["url"];
        } else {
          return this.data.url;
        }
      }
    },
    srcSet() {
      const VM = this;
      let srcset = "";
      Object.keys(VM.data.sizes).map(key => {
        if (VM.data.sizes[key] && VM.data.sizes[key]["url"]) {
          srcset +=
            VM.data.sizes[key]["url"] +
            " " +
            VM.data.sizes[key]["width"] +
            "w, ";
        }
      });
      return srcset;
    }
  }
};
</script>

<style lang="scss">
.image-hold.background-image {
  position: relative;
  .bg-image {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 20;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
  .useholder {
    height: 100%;
    width: 100%;
    position: absolute;
  }
}
.lazyloading {
  position: relative;
  overflow: hidden;
  .bg-image {
    z-index: 10;
  }
  img {
    //display: none;
    &.lazyload {
      //filter: blur(5px);
    }
  }
  &.useholder {
    .lazyloaded {
      ~ .lazy-placeholder {
        opacity: 0;
      }
    }
  }
  .lazy-placeholder {
    position: absolute;
    top: -8px;
    bottom: -8px;
    left: -8px;
    right: -8px;
    z-index: 20;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    filter: blur(8px);
    transition: opacity 0.2s ease-in-out;
    will-change: opacity;
    opacity: 1;
    z-index: 20;
  }
}
</style>
